<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoListar">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoListar">
            <div class="formgroup">
                <div class="p-fluid p-formgrid grid justify-content-end">
                    <div class="field col-12 md:col-6">
                        <div class="flex justify-content-end">
                            <button
                                pButton
                                pRipple
                                label="Contas"
                                icon="pi pi-dollar"
                                class="p-button-outlined w-9rem mr-1"
                                routerLink="/apps/central-cliente/conta"
                            ></button>
                            <button
                                *ngIf="verificarPermissao('PERM_PACOTE_CENTRAL_CLIENTE')"
                                pButton
                                pRipple
                                label="Pacotes"
                                icon="pi pi-credit-card"
                                class="p-button-outlined w-9rem mr-1"
                                routerLink="/apps/central-cliente/pacote/"
                            ></button>
                            <button
                                pButton
                                pRipple
                                label="Retornos"
                                icon="pi pi-directions-alt"
                                class="p-button-outlined w-9rem"
                                routerLink="/apps/central-cliente/retorno"
                            ></button>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                <p-messages
                    [(value)]="messages"
                    [enableService]="false"
                    [closable]="true"
                ></p-messages>
            </div>
            <p-table
                #dt1
                [value]="clientes"
                dataKey="id"
                [rows]="itensPaginados ? itensPaginados.size : 0"
                [loading]="loadingTable"
                [rowHover]="true"
                [paginator]="true"
                (onLazyLoad)="onLazyLoad($event)"
                [totalRecords]="itensPaginados ? itensPaginados.totalElements : 0"
                [lazy]="true"
                [showCurrentPageReport]="true"
                responsiveLayout="stack"
                styleClass=" p-datatable-sm"
                currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros"
            >
                <ng-template pTemplate="caption">
                    <div class="flex justify-content-between flex-column sm:flex-row">
                        <div class="p-fluid w-full sm:w-auto sm:mr-2">
                            <p-dropdown
                                [options]="situacoesStatus"
                                optionLabel="label"
                                optionValue="value"
                                emptyFilterMessage="Nenhum registro"
                                name="situacao"
                                ngModel
                                #situacao="ngModel"
                                [(ngModel)]="situacaoSelecionada"
                                (onChange)="listarClientes(0)"
                            ></p-dropdown>
                        </div>
                        <div class="p-fluid w-full sm:w-auto mt-2 sm:mt-0">
                            <div class="flex">
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input
                                        pInputText
                                        type="text"
                                        #filter
                                        (input)="buscar($event)"
                                        placeholder="Buscar"
                                        class="w-full"
                                    />
                                </span>
                                <span class="ml-2">
                                    <button
                                        pButton
                                        class="p-button-outlined"
                                        icon="pi pi-filter-slash"
                                        pTooltip="Limpar Filtros"
                                        (click)="limpar(dt1)"
                                    ></button>
                                </span>
                            </div>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="nome">
                            Nome
                            <p-sortIcon field="nome"></p-sortIcon>
                        </th>
                        <th pSortableColumn="apelido">
                            Apelido
                            <p-sortIcon field="apelido"></p-sortIcon>
                        </th>

                        <th>Status</th>
                        <th style="text-align: center">
                            <div>Ações</div>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>
                            {{ item.nome }}
                        </td>
                        <td>
                            {{ item.apelido }}
                        </td>

                        <td>
                            <span class="product-badge status-instock" *ngIf="item.status">
                                ATIVO
                            </span>
                            <span class="product-badge status-outofstock" *ngIf="!item.status">
                                INATIVO
                            </span>
                        </td>
                        <td style="text-align: center">
                            <button
                                pButton
                                pRipple
                                pTooltip="Ficha do Cliente"
                                (click)="
                                    redirecionarPagina('/apps/central-cliente/ficha/' + item.id)
                                "
                                icon="pi pi-book"
                                class="p-button-info mr-2 mb-2"
                            ></button>

                            <button
                                pButton
                                pRipple
                                pTooltip="Conta"
                                (click)="
                                    redirecionarPagina(
                                        '/apps/central-cliente/conta/detalhar/' + item.id
                                    )
                                "
                                icon="pi pi-dollar"
                                class="p-button-info mr-2 mb-2"
                            ></button>
                            <button
                                *ngIf="verificarPermissao('PERM_PACOTE_CENTRAL_CLIENTE')"
                                pButton
                                pRipple
                                pTooltip="Pacotes"
                                (click)="redirecionarParaPacote(item)"
                                icon="pi pi-credit-card"
                                class="p-button-info mr-2 mb-2"
                            ></button>
                            <button
                                pButton
                                pRipple
                                pTooltip="Editar"
                                (click)="
                                    redirecionarPagina('/apps/central-cliente/editar/' + item.id)
                                "
                                icon="pi pi-pencil"
                                class="p-button-success mr-2 mb-2"
                            ></button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">Nenhum registro encontrado.</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="loadingbody">
                    <tr>
                        <td colspan="7">Carregando clientes. Por favor aguarde.</td>
                    </tr>
                </ng-template>
            </p-table>

            <p-dialog
                header="Pacotes"
                [(visible)]="exibirDialogContasPacotes"
                [modal]="true"
                [style]="{ width: '50rem' }"
                [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
                [draggable]="false"
                [resizable]="false"
                [closable]="true"
            >
                <div class="formgroup">
                    <div class="p-fluid p-formgrid grid">
                        <div class="field col-12 md:col-12" style="margin-bottom: 0px">
                            <label for="" class="form-control">
                                {{ clienteSelecionado?.nome }}
                            </label>
                        </div>

                        <div class="field col-12 md:col-12" style="margin-bottom: 0px">
                            <p-table
                                #tbPacotes
                                [value]="listaPacotesClienteSelecionado"
                                dataKey="id"
                                [rows]="5"
                                [rowHover]="true"
                                [loading]="loadingDialogPacotes"
                                styleClass="p-datatable-gridlines"
                                [paginator]="true"
                                [globalFilterFields]="['descricao']"
                                responsiveLayout="scroll"
                                styleClass=" p-datatable-sm"
                            >
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th pSortableColumn="tipoPagamentoOrigem.descricao">
                                            Nº
                                            <p-sortIcon
                                                field="tipoPagamentoOrigem.descricao"
                                            ></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="tipoPagamentoDestino.descricao">
                                            Data
                                            <p-sortIcon
                                                field="tipoPagamentoDestino.descricao"
                                            ></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="valorTransferido">
                                            Status
                                            <p-sortIcon field="valorTransferido"></p-sortIcon>
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr>
                                        <td>
                                            {{ item.numeroOrcamento }}
                                        </td>
                                        <td>
                                            {{ item.dataOrcamento | date: "dd/MM/yyyy" }}
                                        </td>
                                        <td>
                                            {{ item.status }}
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="7">Nenhum registro encontrado.</td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="loadingbody">
                                    <tr>
                                        <td colspan="7">Carregando. Por favor aguarde.</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
                <div class="w-full">
                    <p-divider></p-divider>
                </div>
                <div
                    class="p-fluid p-formgrid grid justify-content-end"
                    style="padding-bottom: 0px; margin-bottom: 0px"
                >
                    <div
                        class="field col-12 md:col-4"
                        style="padding-bottom: 0px; margin-bottom: 0px"
                    >
                        <button
                            type="button"
                            pButton
                            icon="pi pi-times"
                            label="Cancelar"
                            class="p-button-primary"
                            (click)="exibirDialogContasPacotes = false"
                        ></button>
                    </div>
                </div>
            </p-dialog>
        </div>
    </div>
</div>
